import * as Types from './types';

export const setOpen = (open: boolean, studentId: string | null) => ({
  type: Types.UNLINK_STUDENT_MODAL_OPEN,
  payload: {
    open,
    studentId
  },
});
